var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceIce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.539,
    height: 53.948,
    viewBox: "0 0 54.539 53.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38718",
    "data-name": "\\uADF8\\uB8F9 38718",
    transform: "translate(1.2 1.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_51",
    "data-name": "\\uD328\\uC2A4 51",
    d: "M2408.086,1132.919v-13.085l-11.332-6.543-11.332,6.543v13.085l11.332,6.543Z",
    transform: "translate(-2385.422 -1113.292)",
    fill: "#f09",
    stroke: "#000c7a",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_52",
    "data-name": "\\uD328\\uC2A4 52",
    d: "M2408.086,1132.919v-13.085l-11.332-6.543-11.332,6.543v13.085l11.332,6.543Z",
    transform: "translate(-2385.422 -1113.292)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_53",
    "data-name": "\\uD328\\uC2A4 53",
    d: "M2404.312,1149.463l6.207,3.584,6.207-3.584",
    transform: "translate(-2399.187 -1139.649)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_45",
    "data-name": "\\uC120 45",
    y1: 6.281,
    transform: "translate(11.332 13.398)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_54",
    "data-name": "\\uD328\\uC2A4 54",
    d: "M2516.721,1132.919v-13.085l-11.332-6.543-11.332,6.543v13.085l11.332,6.543Z",
    transform: "translate(-2464.582 -1113.292)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_55",
    "data-name": "\\uD328\\uC2A4 55",
    d: "M2512.946,1149.463l6.207,3.584,6.208-3.584",
    transform: "translate(-2478.346 -1139.649)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_46",
    "data-name": "\\uC120 46",
    y1: 6.281,
    transform: "translate(40.807 13.398)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_56",
    "data-name": "\\uD328\\uC2A4 56",
    d: "M2461.823,1225.768v-13.085l-11.332-6.543-11.332,6.543v13.085l11.332,6.543Z",
    transform: "translate(-2424.578 -1180.949)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_57",
    "data-name": "\\uD328\\uC2A4 57",
    d: "M2458.048,1242.311l6.207,3.584,6.207-3.584",
    transform: "translate(-2438.343 -1207.306)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_47",
    "data-name": "\\uC120 47",
    y1: 6.281,
    transform: "translate(25.912 38.589)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceIce);
export default __webpack_public_path__ + "static/media/icon-service-ice.e4ca5ecc585a1eaf87a196bcb7073586.svg";
export { ForwardRef as ReactComponent };